export default "__VITE_ASSET__CYs5Ooh1__"